import URI from 'urijs';
import { effects, delay } from 'redux-saga';

import { State as RootState } from '@occc-app/rootRedux';
import { safeAsync } from '@occc-app/lib/safeAsync';
import { getSingleton } from '@occc-app/Activate/api';
import {
  pageableResponseParser,
  pageableResponseErr,
} from '@occc-app/Offer/components/PageableRequest';

import actions from './actions';
import types, { ActionCreators, State } from './types';
import { offersParser } from './apiResponseParsers';

function requestOffersParams(offers: State, chainId: string) {
  if (offers.paths.offers) {
    return new URI(offers.paths.offers).query(true);
  }

  const params: any = {
    include: 'marketing_contents',
    'fields[marketing_contents]': 'title,short_description,subject',
    'filter[publication_status]': offers.filters.publicationStatus,
    'filter[discontinued]': offers.filters.discontinued,
  };

  if (chainId) {
    params['filter[chain_id]'] = chainId;
  }

  if (offers.filters.search) {
    params['filter[search]'] = offers.filters.search;
  }

  return params;
}

function* requestOffers(
  action: ReturnType<ActionCreators['RequestOffers']>,
): Generator<unknown, void, any> {
  if (action.options.delay) {
    yield delay(action.options.delay);
  }

  const core = getSingleton();
  const { offers } = yield effects.select((state: RootState) => ({
    offers: state.offers,
  }));
  const chainId = action.chainId;

  const params = requestOffersParams(offers, chainId);
  const offersData = yield effects.apply(core, core.offers.index, [params]);
  const parsedOffers = offersParser(offersData.data, offersData.included);
  yield effects.put(
    actions.offersOK(parsedOffers, pageableResponseParser(offersData.links, offersData.meta)),
  );
}

export const sagas = {
  requestOffers: safeAsync(requestOffers, (error: Error) =>
    actions.offersERR(pageableResponseErr(), error),
  ),
};

export default function* saga() {
  yield effects.takeLatest(types.REQUEST_OFFERS, sagas.requestOffers);
}
